import { EntityType, CellIndexMapping, ColumnType } from "../util/UIConstants";
import _ = require("lodash");

export class CellAttributes {
  CellHeader: string;
  CellDisplayIndex: number;
  CellFormat: any;
  DataAttributeName: string;
  getCellData: any;
  CellType: CellType;
  CellRangeName: string = "";
  CellId: string = "";
  CellData: any = null;
  IsDocIdValue: boolean = false;
  IsMarkValue: boolean = true;
  cellToBindDropDown: boolean = false;
  referenceData: any = null;
}

export enum CellType {
  DynamicCell = 1,
  Editable = 2,
  Protected = 3,
}

export interface IApiInterface {
  downloadDataAsync: Function;
  saveDataAsync: Function;
  postProcessingSteps?: Function;
}

export interface IColumnConfig {
  columns: any[];
  rowheader?: any[];
  showAtlasLink?: boolean;
  hideSummaryDetails?: boolean;
  formatDependentAPICallData?: Function;
}

export interface IUIExcelInterface {
  getMappedListData?: Function;
  validateInputData?: Function;
  updateWorksheetAfterUpload?: Function;
  populateReferenceSheetAsync?: Function;
  populateInstructionSheetAsync?: Function;
  boundSheetDropDownBinding?: Function;
  applyFormattingOnLoad?: Function;
  applyFormattingOnCellChange?: Function;
  doChangesWhenChangingUpdateEYCanvas?: Function;
}

//entity configuration
export class EntityConfiguration {
  engagementId: string = "";
  configurationType: EntityType = EntityType.Document;
  referenceSheetColumns: any;
  entityConfiguration: IColumnConfig;
  apiInterface: IApiInterface;
  uiExcelInterface: IUIExcelInterface;
  settings: any;
  formatDependentAPICallData: Function;
  constructor(
    columns: any,
    referenceSheetColumns: any,
    engagementId: string,
    configurationType: EntityType,
    entityConfiguration: IColumnConfig
  ) {
    this.engagementId = engagementId;
    for (let i = 0; i < columns.length; i++) {
      columns[i].CellDisplayIndex = i;
    }
    this.columns = _.sortBy(columns, ["CellDisplayIndex"]);
    this.configurationType = configurationType;
    this.referenceSheetColumns = referenceSheetColumns;
    this.entityConfiguration = entityConfiguration;
  }

  getIdAttributeIndex = (columns) => {
    let idColumnIndex = null;
    let idColumn = columns.find((c) => c.IsIdAttribute);
    if (idColumn != null) {
      idColumnIndex = idColumn.CellDisplayIndex;
    }

    return idColumnIndex;
  };

  getStatusAttributeIndex = (columns) => {
    let idColumnIndex = null;
    let idColumn = columns.find((c) => c.IsIdAttribute);
    if (idColumn != null) {
      idColumnIndex = idColumn.CellDisplayIndex;
    }

    return idColumnIndex;
  };

  getAttributeExcelCellName = (columns, cellId) => {
    let excelCellNameStatus = null;
    let statusColumn = columns.find((c) => c.CellId == cellId);
    if (statusColumn != null) {
      excelCellNameStatus = CellIndexMapping[statusColumn.CellDisplayIndex];
    }

    return excelCellNameStatus;
  };

  getEndingDataExcelCellName = (columns) => {
    let excelCellName = null;
    let endColumn = _.sortBy(columns, ["CellDisplayIndex"]).reverse()[0];
    if (endColumn != null) {
      excelCellName = CellIndexMapping[endColumn.CellDisplayIndex];
    }

    return excelCellName;
  };

  columns: CellAttributes[] = [];
}
